document.addEventListener('DOMContentLoaded', function() {
  /*
  const container = document.querySelector('.product-container');
  const items = Array.from(container.children);
  
  // Ocultar todos los elementos primero
  items.forEach(item => item.style.display = 'none');
  
  // Mezclar el array
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }
  
  // Mostrar solo los primeros 8 elementos
  for (let i = 0; i < 8 && i < items.length; i++) {
    items[i].style.display = 'block';
  }
  */


});
